import { useState, useEffect } from 'react';

const STATS = [
  { value: '200+', label: '收录平台' },
  { value: '每日更新', label: '内容更新频率' },
  { value: '人工审核', label: '平台质量保障' },
];

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/30 blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-accent-100/25 blur-3xl translate-y-1/2 -translate-x-1/4"></div>

      <div className="section-container relative z-10 w-full py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div
            className={`flex-1 w-full text-center lg:text-left transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-5">
              2025 · 全网吃瓜第一站
            </span>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              吃瓜爆料网
              <br className="md:hidden" />
              <span className="text-primary-600"> — 全网吃瓜爆料一站式导航平台</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-[580px] mx-auto lg:mx-0 mb-6">
              汇聚全网最新、最热的吃瓜爆料网站，涵盖娱乐圈八卦、网红动态、热点事件追踪等多个维度。每日更新平台收录，人工审核确保质量，让你不错过任何一个值得关注的吃瓜爆料网站，一站导航，轻松直达。
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-[580px] mx-auto lg:mx-0 mb-8">
              2025年吃瓜爆料网站持续涌现，我们持续追踪各类新平台，提供及时准确的推荐与排名，帮助你快速筛选出高质量、更新快的吃瓜爆料网站。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {STATS.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading font-bold text-primary-600">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                浏览吃瓜导航
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-secondary-300 text-foreground-700 font-medium text-sm whitespace-nowrap hover:bg-secondary-50 transition-colors cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看热门排行
              </a>
            </div>
          </div>

          <div
            className={`flex-1 w-full max-w-[500px] lg:max-w-none transition-all duration-700 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/30 to-accent-200/30 rounded-2xl blur-xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-background-200/60">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20editorial%20photography%20style%20with%20warm%20coral%20and%20amber%20ambient%20lighting%2C%20abstract%20composition%20suggesting%20digital%20news%20media%20and%20entertainment%20gossip%2C%20soft%20shadows%2C%20clean%20minimalist%20background%20with%20subtle%20texture%2C%20sophisticated%20magazine%20layout%20aesthetic%2C%20high%20detail%20professional%20photography%2C%20harmonious%20warm%20color%20palette%2C%20no%20visible%20text%2C%20artistic%20light%20leaks%20suggesting%20dynamic%20information%20flow%2C%20editorial%20newsroom%20atmosphere&width=800&height=600&seq=hero-main-2026&orientation=landscape"
                  alt="吃瓜爆料网 - 全网吃瓜爆料一站式导航平台主视觉"
                  className="w-full h-auto object-cover"
                  width="800"
                  height="600"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}